module.exports = __webpack_public_path__ + "img/744.065cd9ca.png";